import React from "react";
import { HStack, Box } from "@chakra-ui/react";

const Stepper = ({
  step,
  totalSteps,
  color,
  justifyContent,
}: {
  step: number
  totalSteps: number
  color: string
  justifyContent?: string | string[]
}) => (
  <HStack
    py={5}
    w="full"
    spacing="24px"
    justifyContent={justifyContent || undefined}
  >
    {Array.from({ length: totalSteps }).map((_, i) => (
      <Box
        key={i}
        w="80px"
        h={1.5}
        bg={i === step ? color : "gray.200"}
        transition="all 300ms ease"
      />
    ))}
  </HStack>
);

export default Stepper;
